<template>
  <footer>
    <ul>
      <li>
        <a href="https://www.danogips.de/wir-fuer-sie/datenschutz/" target="_blank">Datenschutz</a>
      </li>
      <li>
        <a href="https://www.danogips.de/wir-fuer-sie/impressum/" target="_blank">Impressum</a>
      </li>
      <li>
        <a href="https://www.danogips.de/agb/" target="_blank">AGB</a>
      </li>
    </ul>

    <p>&#169; 2020 Danogips</p>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style lang="scss" scoped>
/* Footer */
footer {
  background-color: $color-footer-background;
  display: block;
  padding: 21px 0 24px;
  text-align: center;
  width: 100%;

  @include center-max-width;

  ul {
    list-style-type: none;
    margin: 0 0 14px;
    padding: 0;

    li {
      display: inline-block;
      margin: 0;
      padding: 0 40px 0 0;

      a {
        color: $color-white;
        font-size: 14px;
        line-height: 17px;
        text-decoration: none;
      }

      &:last-of-type {
        margin: 0;
        padding: 0;
      }
    }
  }

  p {
    color: $color-footer-text;
    font-size: 14px;
    line-height: 17px;
    margin: 0;
  }
}
</style>
